<div class="main-breadcrumb" *ngIf="breadcrumb.length">
  <div class="container">
    <div class="breadcrumb-wrapper align-items-center d-flex mb-2">
      <ng-container *ngFor="let item of breadcrumb; let i = index">
        <ng-container *ngIf="i !== breadcrumb.length - 1">
          <a class="breadcrumb-item" [routerLink]="item.url">
            {{ item.title }}
          </a>

          <img
            *ngIf="i !== breadcrumb.length - 2"
            alt="chevron"
            src="assets/icons/chevron.svg" />
        </ng-container>
      </ng-container>
    </div>
    <span class="breadcrumb-current">{{
      breadcrumb[breadcrumb.length - 1].title | translate
    }}</span>
  </div>
</div>
